import { combineReducers } from 'redux';
import { configApp } from './config.reducer';
import { batch } from './batch.reducer';

export default combineReducers({
  configApp,
  batch,
})